import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitoashtavinayakcabservice() {



    const cardData = {




keyword: "Mumbai to Ashtavinayak Cab Service",

headingDescription: "Shreesha Tours & Travels offers reliable and comfortable Mumbai to Ashtavinayak cab services for devotees, families, senior citizens, and groups planning a spiritual pilgrimage across Maharashtra. We provide one-way cabs, round-trip taxi services, complete Ashtavinayak tour packages, and customized travel itineraries with professional chauffeurs and well-maintained vehicles. Our fleet includes Sedan, Swift Dzire, Ertiga, SUV, Innova, Innova Crysta, Tempo Traveller, Urbania, Mini Bus, and luxury vehicles suitable for every group size and travel budget. With doorstep pickup anywhere in Mumbai, flexible travel schedules, transparent pricing, easy online booking, and 24/7 customer support, Shreesha Tours & Travels ensures a safe, comfortable, and hassle-free pilgrimage experience. Whether you wish to complete the sacred Ashtavinayak Yatra in one day, two days, or a customized multi-day tour, we provide clean vehicles, experienced drivers familiar with the temple routes, and personalized travel services to make your spiritual journey peaceful, memorable, and convenient.",

topPlaces: [
  {
    title: "Mayureshwar Temple, Morgaon",
    description: "Mayureshwar Temple at Morgaon is considered the first and most important temple of the sacred Ashtavinayak Yatra. Dedicated to Lord Ganesha, the temple is believed to grant wisdom, prosperity, and success. Devotees from across India begin and conclude their Ashtavinayak pilgrimage here according to traditional customs."
  },
  {
    title: "Siddhivinayak Temple, Siddhatek",
    description: "Siddhatek is home to the revered Siddhivinayak Temple, where Lord Ganesha is worshipped as the bestower of success and fulfillment. Located on the banks of the Bhima River, the temple offers a peaceful spiritual atmosphere and is one of the most important stops during the Ashtavinayak pilgrimage."
  },
  {
    title: "Ballaleshwar Temple, Pali",
    description: "Ballaleshwar Temple in Pali is the only Ashtavinayak temple named after a devotee rather than Lord Ganesha himself. The temple is famous for its beautiful architecture, rich history, and the inspiring story of the young devotee Ballal, attracting thousands of pilgrims every year."
  },
  {
    title: "Varadvinayak Temple, Mahad",
    description: "Varadvinayak Temple is renowned as the temple where Lord Ganesha blesses devotees with prosperity and fulfills sincere wishes. The sacred lamp inside the temple is believed to have been continuously burning for many years, making it a spiritually significant destination."
  },
  {
    title: "Chintamani Temple, Theur",
    description: "Chintamani Temple at Theur is dedicated to Lord Ganesha as the remover of worries and anxiety. Surrounded by peaceful surroundings, the temple attracts devotees seeking mental peace, happiness, and divine blessings throughout the year."
  },
  {
    title: "Girijatmaj Temple, Lenyadri",
    description: "Girijatmaj Temple is uniquely carved into a series of ancient rock-cut caves and is the only Ashtavinayak temple located on a hill. Devotees climb several steps to reach the shrine while enjoying panoramic views of the surrounding landscape and experiencing its historical and spiritual significance."
  },
  {
    title: "Vighnahar Temple, Ozar",
    description: "Vighnahar Temple at Ozar is dedicated to Lord Ganesha as the remover of obstacles. The temple is admired for its impressive architecture, beautifully decorated entrance, peaceful environment, and vibrant celebrations during Ganesh festivals."
  },
  {
    title: "Mahaganapati Temple, Ranjangaon",
    description: "Mahaganapati Temple at Ranjangaon is the final temple in the traditional Ashtavinayak circuit. It is believed that Lord Ganesha blessed Lord Shiva here before his battle against the demon Tripurasura. The temple is known for its spiritual importance, magnificent architecture, and serene surroundings."
  },
  {
    title: "Jejuri",
    description: "Jejuri is a famous pilgrimage destination dedicated to Lord Khandoba and is often included in extended Ashtavinayak tour itineraries. The temple is well known for its grand celebrations, yellow turmeric festival, and hilltop location offering panoramic views of the surrounding region."
  },
  {
    title: "Pune",
    description: "Pune serves as the main gateway for the Ashtavinayak pilgrimage, offering excellent road connectivity to all eight temples. The city is also home to famous attractions, comfortable accommodations, restaurants, and shopping destinations, making it a convenient stop during the spiritual journey."
  }
],



"services": [
  {
    "name": "Mumbai to Ashtavinayak Cab",
    "description": "Book Mumbai to Ashtavinayak Cab for safe, comfortable, and reliable pilgrimage travel with professional chauffeurs and well-maintained AC vehicles. Choose Sedan, Ertiga, Innova Crysta, SUV, and premium cabs for temple darshan, family trips, and tour packages."
  },
  {
    "name": "Mumbai to Ashtavinayak Taxi",
    "description": "Hire Mumbai to Ashtavinayak Taxi with experienced drivers, affordable fares, and comfortable vehicles for a smooth temple journey."
  },
  {
    "name": "Mumbai to Ashtavinayak Cab Service",
    "description": "Book Mumbai to Ashtavinayak Cab Service with doorstep pickup, professional chauffeurs, and flexible one way and round trip travel options."
  },
  {
    "name": "Mumbai to Ashtavinayak Taxi Service",
    "description": "Choose Mumbai to Ashtavinayak Taxi Service for reliable pilgrimage transportation with clean AC vehicles and transparent pricing."
  },
  {
    "name": "Mumbai to Ashtavinayak Tour Cab",
    "description": "Reserve Mumbai to Ashtavinayak Tour Cab for a comfortable sightseeing and temple tour with experienced chauffeurs and premium vehicles."
  },
  {
    "name": "Mumbai to Ashtavinayak Darshan Cab",
    "description": "Book Mumbai to Ashtavinayak Darshan Cab for a convenient pilgrimage experience with reliable drivers and comfortable travel."
  },
  {
    "name": "Mumbai to Ashtavinayak Cab Booking",
    "description": "Complete Mumbai to Ashtavinayak Cab Booking online with instant confirmation and multiple vehicle options."
  },
  {
    "name": "Mumbai to Ashtavinayak Tour Package",
    "description": "Choose Mumbai to Ashtavinayak Tour Package with comfortable cabs, flexible itineraries, and hassle-free temple sightseeing."
  },
  {
    "name": "Mumbai to Ashtavinayak Car Rentals",
    "description": "Hire Mumbai to Ashtavinayak Car Rentals with chauffeur-driven Sedan, Ertiga, Innova Crysta, and SUV vehicles."
  },
  {
    "name": "Mumbai to Ashtavinayak Outstation Cab",
    "description": "Book Mumbai to Ashtavinayak Outstation Cab with experienced drivers and comfortable AC vehicles for long-distance temple travel."
  },
  {
    "name": "Mumbai to Ashtavinayak Innova Cab",
    "description": "Reserve Mumbai to Ashtavinayak Innova Cab for spacious family travel with premium comfort and luggage space."
  },
  {
    "name": "Mumbai to Ashtavinayak Innova Crysta Cab",
    "description": "Book Mumbai to Ashtavinayak Innova Crysta Cab for luxury pilgrimage travel with spacious seating and professional chauffeurs."
  },
  {
    "name": "Mumbai to Ashtavinayak Ertiga Cab",
    "description": "Choose Mumbai to Ashtavinayak Ertiga Cab for affordable 6 to 7 seater family travel with comfortable interiors."
  },
  {
    "name": "Mumbai to Ashtavinayak Sedan Cab",
    "description": "Hire Mumbai to Ashtavinayak Sedan Cab for economical and comfortable travel with clean AC vehicles."
  },
  {
    "name": "Mumbai to Ashtavinayak Swift Dzire Cab",
    "description": "Book Mumbai to Ashtavinayak Swift Dzire Cab for budget-friendly travel with experienced chauffeurs and reliable service."
  },
  {
    "name": "Mumbai to Ashtavinayak SUV Taxi",
    "description": "Reserve Mumbai to Ashtavinayak SUV Taxi for spacious group travel with additional luggage capacity and premium comfort."
  },
  {
    "name": "Mumbai to Ashtavinayak Kia Carens Cab",
    "description": "Choose Mumbai to Ashtavinayak Kia Carens Cab for modern, spacious, and comfortable family travel."
  },
  {
    "name": "Mumbai to Ashtavinayak Luxury Cab",
    "description": "Book Mumbai to Ashtavinayak Luxury Cab for premium chauffeur-driven travel with luxury vehicles and superior comfort."
  },
  {
    "name": "Mumbai to Ashtavinayak AC Taxi",
    "description": "Hire Mumbai to Ashtavinayak AC Taxi with clean air-conditioned vehicles and experienced professional drivers."
  },
  {
    "name": "Mumbai to Ashtavinayak Tempo Traveller",
    "description": "Reserve Mumbai to Ashtavinayak Tempo Traveller for group tours, family pilgrimages, and comfortable temple travel."
  },
  {
    "name": "Mumbai Airport to Ashtavinayak Cab",
    "description": "Book Mumbai Airport to Ashtavinayak Cab with direct airport pickup and reliable chauffeur-driven transportation."
  },
  {
    "name": "Navi Mumbai to Ashtavinayak Cab",
    "description": "Choose Navi Mumbai to Ashtavinayak Cab with affordable pricing and comfortable outstation travel."
  },
  {
    "name": "Thane to Ashtavinayak Cab",
    "description": "Hire Thane to Ashtavinayak Cab with experienced chauffeurs and premium AC vehicles for safe pilgrimage travel."
  },
  {
    "name": "Panvel to Ashtavinayak Taxi",
    "description": "Book Panvel to Ashtavinayak Taxi with convenient pickup, affordable fares, and comfortable vehicles."
  },
  {
    "name": "Kalyan to Ashtavinayak Cab",
    "description": "Reserve Kalyan to Ashtavinayak Cab with professional drivers and reliable long-distance transportation."
  },
  {
    "name": "Dombivli to Ashtavinayak Taxi",
    "description": "Choose Dombivli to Ashtavinayak Taxi with flexible booking options and comfortable AC vehicles."
  },
  {
    "name": "Borivali to Ashtavinayak Cab",
    "description": "Book Borivali to Ashtavinayak Cab with experienced chauffeurs, premium vehicles, and affordable travel packages."
  }
],
"tableData": [
  ["Mumbai to Ashtavinayak Cab", "Mumbai to Ashtavinayak Taxi"],
  ["Mumbai to Ashtavinayak Cab Service", "Mumbai to Ashtavinayak Taxi Service"],
  ["Mumbai to Ashtavinayak Tour Cab", "Mumbai to Ashtavinayak Darshan Cab"],
  ["Mumbai to Ashtavinayak Cab Booking", "Mumbai to Ashtavinayak Tour Package"],
  ["Mumbai to Ashtavinayak Car Rentals", "Mumbai to Ashtavinayak Outstation Cab"],
  ["Mumbai to Ashtavinayak Innova Cab", "Mumbai to Ashtavinayak Innova Crysta Cab"],
  ["Mumbai to Ashtavinayak Ertiga Cab", "Mumbai to Ashtavinayak Sedan Cab"],
  ["Mumbai to Ashtavinayak Swift Dzire Cab", "Mumbai to Ashtavinayak SUV Taxi"],
  ["Mumbai to Ashtavinayak Kia Carens Cab", "Mumbai to Ashtavinayak Luxury Cab"],
  ["Mumbai to Ashtavinayak AC Taxi", "Mumbai to Ashtavinayak Tempo Traveller"],
  ["Mumbai Airport to Ashtavinayak Cab", "Navi Mumbai to Ashtavinayak Cab"],
  ["Thane to Ashtavinayak Cab", "Panvel to Ashtavinayak Taxi"],
  ["Kalyan to Ashtavinayak Cab", "Dombivli to Ashtavinayak Taxi"],
  ["Borivali to Ashtavinayak Cab", ""]
],




whychoose: [
  {
    WhyChooseheading: "Trusted Mumbai to Ashtavinayak Cab Service",
    WhyChoosedescription: "Shreesha Tours & Travels offers reliable Mumbai to Ashtavinayak cab services with comfortable vehicles, experienced chauffeurs, and customized pilgrimage packages for a peaceful and memorable journey."
  },
  {
    WhyChooseheading: "Complete Ashtavinayak Darshan Tour",
    WhyChoosedescription: "Visit all eight sacred Ashtavinayak Ganpati temples with a private cab, allowing you to travel comfortably while following your preferred darshan schedule."
  },
  {
    WhyChooseheading: "Comfortable Fleet for Every Group",
    WhyChoosedescription: "Choose from Swift Dzire, Sedan, Ertiga, Innova, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles suitable for solo travellers, families, and large groups."
  },
  {
    WhyChooseheading: "Flexible Tour Packages",
    WhyChoosedescription: "Book one-day, two-day, or customized Ashtavinayak tour packages with one-way, round-trip, or multi-day travel plans based on your itinerary."
  },
  {
    WhyChooseheading: "Experienced Drivers for Pilgrimage Routes",
    WhyChoosedescription: "Our professional drivers are familiar with all Ashtavinayak temple routes, ensuring safe driving, timely arrivals, and a comfortable travel experience."
  },
  {
    WhyChooseheading: "Customizable Temple & Sightseeing Stops",
    WhyChoosedescription: "Along with the eight Ganpati temples, you can include Jejuri, Bhimashankar, Prati Balaji Temple, or other nearby religious and sightseeing destinations."
  },
  {
    WhyChooseheading: "Clean & Well-Maintained Vehicles",
    WhyChoosedescription: "Travel in air-conditioned, hygienic, and regularly serviced vehicles with spacious seating and ample luggage space for a relaxing pilgrimage."
  },
  {
    WhyChooseheading: "Easy Booking with Shreesha Tours & Travels",
    WhyChoosedescription: "Reserve your Mumbai to Ashtavinayak cab quickly with transparent pricing, prompt customer support, and personalized travel assistance."
  }
]

};

const faqData = [
  {
    question: "Does Shreesha Tours & Travels provide Mumbai to Ashtavinayak Cab Service?",
    answer: "Yes, we provide Mumbai to Ashtavinayak cab services with customized pilgrimage packages for individuals, families, and groups."
  },
  {
    question: "Can I book a private cab for the complete Ashtavinayak Yatra?",
    answer: "Yes, private taxis are available for the complete Ashtavinayak Darshan with flexible travel schedules."
  },
  {
    question: "Which vehicles are available for the Ashtavinayak tour?",
    answer: "You can choose from Swift Dzire, Sedan, Ertiga, Innova, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles."
  },
  {
    question: "Can I book a one-day or two-day Ashtavinayak package?",
    answer: "Yes, we offer one-day, two-day, and customized multi-day tour packages according to your travel preferences."
  },
  {
    question: "Is the cab suitable for family pilgrimage trips?",
    answer: "Yes, our spacious vehicles are ideal for families, senior citizens, groups, and devotees travelling together."
  },
  {
    question: "Can I include Bhimashankar or Jejuri in my itinerary?",
    answer: "Yes, your tour can be customized to include Bhimashankar Jyotirlinga, Jejuri Temple, Prati Balaji Temple, and other nearby attractions."
  },
  {
    question: "Do you provide pickup from Mumbai Airport, hotels, and railway stations?",
    answer: "Yes, pickup is available from Mumbai Airport, railway stations, hotels, homes, offices, and any preferred location in Mumbai."
  },
  {
    question: "Are tolls and parking charges included in the fare?",
    answer: "Toll charges, parking fees, permits, and additional expenses depend on the selected package and are explained before booking."
  },
  {
    question: "Is Mumbai to Ashtavinayak cab service available throughout the week?",
    answer: "Yes, Shreesha Tours & Travels provides cab services seven days a week based on advance booking and vehicle availability."
  },
  {
    question: "How can I book a Mumbai to Ashtavinayak Cab Service?",
    answer: "Share your travel date, pickup location, number of passengers, preferred vehicle, and tour duration to receive your quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Mahesh Kulkarni",
    feedback: "Our Ashtavinayak Yatra with Shreesha Tours & Travels was beautifully organized. The driver knew all the temple routes, and the vehicle was clean and comfortable throughout the trip.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Vaishali Patil",
    feedback: "We booked an Innova Crysta for our family pilgrimage. The service was punctual, the cab was spacious, and the entire Ashtavinayak tour was peaceful and hassle-free.",
    rating: 5
  }
];





    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Ashtavinayak Cab Service",
  "image": "https://www.shreeshatravels.com/assets/images/mumbai-to-ashtavinayak-cab-service.webp",
  "description":
    "Book Mumbai to Ashtavinayak Cab Service with Shreesha Tours & Travels for safe, comfortable, and affordable pilgrimage taxi services. We provide one-way and round-trip cabs from Mumbai to the Ashtavinayak temples with Sedan, Ertiga, SUV, Innova, and Innova Crysta available 24x7 for Ganpati darshan, family tours, temple visits, and customized travel packages.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/mumbai-to-ashtavinayak-cab-service"
  }
};






    return (
        <div>
<Helmet>
  <title>Mumbai to Ashtavinayak Cab Service | Ganpati Darshan Taxi | +91 8355835813</title>

  <meta
    name="description"
    content="Book Mumbai to Ashtavinayak Cab Service with Shreesha Travels for reliable one-way and round-trip pilgrimage taxi services. Hire Sedan, Ertiga, SUV, Innova, and Innova Crysta for comfortable Ashtavinayak Darshan tours with 24x7 online cab booking."
  />

  <meta
    name="keywords"
    content="Mumbai to Ashtavinayak Cab, Mumbai to Ashtavinayak Taxi, Mumbai to Ashtavinayak Cab Service, Mumbai to Ashtavinayak Taxi Service, Mumbai to Ashtavinayak Tour Cab, Mumbai to Ashtavinayak Darshan Cab, Mumbai to Ashtavinayak Cab Booking, Mumbai to Ashtavinayak Tour Package, Mumbai to Ashtavinayak Car Rentals, Mumbai to Ashtavinayak Outstation Cab, Mumbai to Ashtavinayak One Way Cab, Mumbai to Ashtavinayak Round Trip Cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/10.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mumbaitoashtavinayakcabservice;